import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    className: 'events-slider',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      $( '.events-slider__splide' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'slide',
          arrows: true,
          gap: '2rem',
          autoWidth: true,
          pagination: false,
          paginationKeyboard: true,
          omitEnd: true,
          focus: 0,
          trimSpace: false,
          breakpoints: {
            768: {
              omitEnd: false,
              // trimSpace: false,
              autoWidth: false,
              perPage: 1,
            },
          },
        } );
        slider.on( 'overflow', function( isOverflow ) {
          slider.options = {
            drag: isOverflow,
            arrows: isOverflow,
          };
        } );
        slider.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'events-slider', COMPONENT );
} )( app );
